import { useEffect } from 'react';
import styled from 'styled-components';

import { JsonView } from 'ui/treeView';

import { smallShadow, spacing, colors } from 'ui/theme';
import { useExpansionContext } from 'utils/contexts/expansion';
import { pxToRem } from 'utils/convert';

import { NoResults } from './NoResults';
import { useFieldsFilterContext } from './filter';
import { useFieldsSearch } from './hooks/useFieldsSearch';

const TableWrapper = styled.div`
  box-shadow: ${smallShadow.boxShadow};
  border-radius: ${spacing.half};
  border: ${pxToRem(1)} solid ${colors.grey5};
  padding: ${spacing.plusHalf};
  background-color: ${colors.white};
`;

export const FieldsDisplay = () => {
  const { search } = useFieldsFilterContext();
  const { expand } = useExpansionContext();
  const { data, isMatch } = useFieldsSearch();

  useEffect(() => {
    if (search.length > 0) {
      expand();
    }
  }, [search]);

  return isMatch ? (
    <TableWrapper>
      <JsonView
        collapseByDefault
        highlight={search === '' ? undefined : search}
        storageKey="user-fields"
        src={data ?? {}}
        sort
      />
    </TableWrapper>
  ) : (
    <NoResults />
  );
};
